import { ThemePayloadProps } from "../pages/DashboardSetup";
import {
  addCompanyTheme,
  updateCompanyTheme,
} from "../services/api/themeHandler";
import { CONSTANTS } from "../constants/Constants";

export const getInitials = (firstName?: any, lastName?: any) => {
  let initials;
  if (lastName)
    initials = `${firstName?.charAt(0)}${lastName?.charAt(0)}`.toUpperCase();
  else initials = `${firstName.charAt(0)}`.toUpperCase();
  return initials;
};

export const localStorageHandler = <T>(
  action: "get" | "set" | "remove" | "clear",
  key?: string | "",
  data?: T
): T | null | void => {
  try {
    if (action === "get") {
      const item = localStorage.getItem(key || "");
      return item ? (JSON.parse(item) as T) : null;
    } else if (action === "set" && data !== undefined) {
      localStorage.setItem(key || "", JSON.stringify(data));
    } else if (action === "remove") {
      localStorage.removeItem(key || "");
    } else if (action === "clear") {
      localStorage.clear();
    }
  } catch (error) {
    console.error("Error handling localStorage action:", error);
    return null;
  }
};

export const handleDragStart = (index: number, dragItem: any) => {
  dragItem.current = index;
};

export const handleDragEnter = (index: number, dragOverItem: any) => {
  dragOverItem.current = index;
};

export const errorHandler = (res: any) => {
  let error;

  if (
    res?.error?.response?.data?.errors &&
    Object.keys(res?.error?.response?.data?.errors)?.length > 0
  ) {
    error =
      res?.error?.response?.data?.errors[
        Object.keys(res?.error?.response?.data?.errors)[0]
      ][0];
  } else if (res?.response?.data?.errors) {
    error =
      res?.response?.data?.errors[
        Object.keys(res?.response?.data?.errors)[0]
      ][0];
  } else if (res?.error?.response) {
    error = res?.error?.response?.data?.message;
  } else if (res?.response?.data?.message) {
    error = res?.response?.data?.message;
  } else {
    error = res?.error?.message;
  }
  return error;
};

export const convertToFormData = (payload: any): FormData => {
  const formData = new FormData();

  Object.entries(payload).forEach(([key, value]) => {
    const newKey = key === "cityId" ? "locationId" : key; // Convert 'cityId' to 'locationId'

    if (value instanceof File) {
      // Directly append File objects
      formData.append(newKey, value);
    } else if (Array.isArray(value)) {
      // Handle arrays
      value.forEach((item, index) => {
        if (item instanceof File) {
          formData.append(`${newKey}[${index}]`, item);
        } else if (typeof item === "object" && item !== null) {
          // Handle nested objects in arrays
          Object.entries(item).forEach(([subKey, subValue]) => {
            const nestedKey = subKey === "cityId" ? "locationId" : subKey; // Handle nested 'cityId'
            formData.append(
              `${newKey}[${index}].${nestedKey}`,
              subValue instanceof File ? subValue : subValue?.toString() || ""
            );
          });
        } else {
          formData.append(`${newKey}[${index}]`, item?.toString() || "");
        }
      });
    } else if (typeof value === "object" && value !== null) {
      // Handle plain objects
      Object.entries(value).forEach(([subKey, subValue]) => {
        const nestedKey = subKey === "cityId" ? "locationId" : subKey; // Handle nested 'cityId'
        formData.append(
          `${newKey}.${nestedKey}`,
          subValue instanceof File ? subValue : subValue?.toString() || ""
        );
      });
    } else if (value !== undefined && value !== null) {
      // Handle basic key-value pairs
      formData.append(newKey, value.toString());
    }
  });

  return formData;
};

export const copyToClipboard = async (text: string, showToast: any) => {
  try {
    const textToCopy = text;
    await navigator.clipboard.writeText(textToCopy);
    showToast("Text copied to clipboard!", "success");
  } catch (err) {
    showToast("Failed to copy text", "error");
    console.error("Failed to copy text: ", err);
  }
};

export const feedbackFormHandler = () => {
  const googleFormLink =
    "https://docs.google.com/forms/d/1SUqVL2EMXREZ_DGnrWdpx3tsFRgd5o7HEnjpLhMFsvY/edit";
  window.open(googleFormLink, "_blank");
};

export const submitBrandingHandler = async (
  themePayload: ThemePayloadProps,
  isUpdate?: boolean
) => {
  let finalPayload = convertToFormData(themePayload);
  let res = (await isUpdate)
    ? updateCompanyTheme(finalPayload)
    : addCompanyTheme(finalPayload);
  return res;
};

export const getAvailabilityColor = (availabilityStatus?: string) => {
  switch (availabilityStatus) {
    case CONSTANTS.AVAILABILITY_IMMEDIATELY_CODE_TXT:
      return CONSTANTS.APP_DEFAULT_COLORS.PRIMARY_COLOR;
    case CONSTANTS.AVAILABLE_ON_DATE_CODE_TXT:
      return CONSTANTS.APP_DEFAULT_COLORS.BLACK_COLOR;
    default:
      return CONSTANTS.APP_DEFAULT_COLORS.ORANGE_COLOR;
  }
};

export const getAvailabilityText = (availabilityStatus?: string) => {
  switch (availabilityStatus) {
    case CONSTANTS.AVAILABILITY_IMMEDIATELY_CODE_TXT:
      return CONSTANTS.AVAILABILITY_IMMEDIATELY_TXT;
    case CONSTANTS.AVAILABLE_ON_DATE_CODE_TXT:
      return CONSTANTS.AVAILABLE_ON_DATE_TXT;
    default:
      return CONSTANTS.NOT_AVAILABLE_TXT;
  }
};
